module.exports = __webpack_public_path__ + "media/images/views/home/step/step-3-990a7ccbf404a4fccd07145113b43139.png";